var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABHNCSVQICAgIfAhkiAAAAztJREFUeJzt3SFv20AUB/D37IE0KizcBxgoqLR9hEnd2EDJwEC/wQymNjkwUDkBC6gURSOTUrBKkwZGBwtaqUUbCBgYGKgUMmAQVa2U5g3MlabVvuYujl5t/3/Qzt1Z9885l5N1JgIAAACoIy6qojiOJeu4MaawNpZJ6/qDZVYOd0MAyhCAMgSgDAEoc/qFj+N4nZmfishjItogovXlXNa99YOIRsx8Fobh8c7OzumiFc4VwHA4bIzH4z0ReU1EDxZttEIOms1mFEVR4lvBnQHEcbxORJ+J6JFvIxV3Hobhy93d3WOfwtbfgOFw2CB0/l0eXl9ff+n1ems+ha0BjMfjPULnz2Pt6urqvU/B3FtQeuv5Rrjnzy0IguetVuurS5nczk1nO1nnp8y8LyKHxpjvNwfrsBaUfim3iMhQRt+JyCYRFRNAOtW8hZn32+32G5dGqsIYMyKiUafTmYjIu//Pi8gT1zptvwEbWQdF5NC1kapZWVn5kHMqs89sbAFk/sn697ZTV5Z5/6prXViKUIYAlBU2xSzLbCeP1vVjBChDAMoQgDIEoAwBKHOeBeWtmYAfjABlCEAZAlCGAJQhAGXOs6Cyr/kUpajZIEaAMgSgDAEoQwDKEIAytYeuXJ8jum+fLwpGgDIEoAwBKEMAyhCAMtvj6aV+2nnZiuofjABlCEAZAlCGAJQhAGWFrQXdt7UarAXBXBCAMgSgDAEoQwDKsBbkCWtBFYEAlCEAZQhAGQJQVtm1oLLACFCGAJQhAGUIQBkCUKa2X9CyP18WGAHKEIAyWwA/sw52Op3ab2U8GAzydke8dK3LFkDe9pQvXBupmiRJtnJOjVzrsm1dfCYitxoSkbfdbnfSaDQ+LrJvfhkNBoPVtPP7WeeZ2fmFDrkBhGF4PJ1Os041ZrNZ/+Lioh/HsWt7pZYk9u+biJy41pl7C0pfz3HgWmFdMfORMeaTaznrLKjZbEZEdO59VfUxYeZtn4LWAKIoSoIgeEVEv70uqx4mzLzdarV++RSe699lr9e7eUNE3q9/LTHz0SKdT+T4Gqtut/tMRDbTffI3yGO38JK7pL+vsToVkROfez4AAAAAAAAAANTXH3peFtQcQ9QsAAAAAElFTkSuQmCC",
    id: "img_1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#img_1",
    fill: "#FFFFFF",
    stroke: "none",
    transform: "scale(0.1875 0.1875)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.fee011cb9cb869a219846b5be0353dbe.svg";
export { ForwardRef as ReactComponent };